import Vue from "vue";
import {groupArchiveDataBySite} from "@/utils/utils";

export default {
    setQueryData: async ({commit}, queryData) => {
        commit('setQueryData', queryData)
    },
    setQueryDataSites: async ({commit}, queryData) => {
        commit('setQueryDataSites', queryData)
    },
    setSelectedArchiveProject: async ({commit, dispatch}, selectedProject) => {
        if (selectedProject) {
            const payload = {
                lambdaName: "check_archiving_status",
                query: {
                    "triggerBy": "project",
                    "id": selectedProject._id,
                    "processingPeriods": [],
                    "userEmails": []
                }
            }
            let config = {
                method: 'post',
                url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/archiver-lambda-wrapper',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: payload
            };
            return await Vue.prototype.$http(config)
                .then(async (response) => {
                    console.log('Get project report response: ', response)
                    if (response.data.errorMessage) {
                        return Error(response.data.errorMessage)
                    } else if (response.data.type && response.data.type === 'error') {
                        return Error(response.data.message)
                    } else if (response.status === 200) {
                        commit('setSelectedArchiveProject', selectedProject)

                        const grouped = groupArchiveDataBySite(response.data)
                        console.log("Grouped: ", grouped)
                        commit('setSelectedStatusDataBySite', grouped)
                        await dispatch('getProjectRules', selectedProject._id)
                    }
                    return response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

        } else {
            commit('setSelectedArchiveProject', null)
            commit('setSelectedStatusDataBySite', [])
            commit('setProjectRule', null)
        }
    },
    addNewRule: async ({commit, dispatch}, rule) => {
        const payload = {
            lambdaName: "create_archiving_rules",
            query: rule
        }

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/archiver-lambda-wrapper',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Add new rule response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    //commit('setReport', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    updateRule: async ({commit, dispatch}, rule) => {
        const payload = {
            lambdaName: "update_archiving_rules",
            query: rule
        }

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/archiver-lambda-wrapper',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Add new rule response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    //commit('setReport', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    deleteRule: async ({commit}, ruleId) => {
        const payload = {
            lambdaName: "delete_archiving_rules",
            query: {
                deleteOnlySelectedTypeIds: true,
                selectedType: "archivingRuleId",
                selectedIds: [ruleId],
                userEmails: ["aleksandari@realtimetraffic.com.au"]
            }
        }

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/archiver-lambda-wrapper',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Delete rule response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    getProjectRules: async ({commit, dispatch}, projectId) => {

        const payload = {
            lambdaName: "find_all_archiving_rules_in_a_project",
            query: {
                projectId: projectId
            }
        }

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/archiver-lambda-wrapper',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Check all project rules: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    commit('setProjectRules', response.data.rulesWithinProject)
                    commit('setAppliedProjectRule', response.data.appliedProjectArchivingRule)
                    commit('setAppliedSiteRules', response.data.appliedSiteArchivingRules)
                    commit('setAppliedDeviceRules', response.data.appliedDataDeviceArchivingRules)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    triggerArchiving: async ({commit, dispatch}, query) => {
        const payload = {
            lambdaName: "trigger_archive_videos",
            query: query
        }

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/archiver-lambda-wrapper',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Add new rule response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    //commit('setReport', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    triggerRestoring: async ({commit, dispatch}, query) => {
        const payload = {
            lambdaName: "trigger_restore_videos",
            query: query
        }

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/archiver-lambda-wrapper',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Add new rule response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    //commit('setReport', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    triggerCloning: async ({commit, dispatch}, query) => {
        const payload = {
            lambdaName: "cloning_data_between_environments",
            query: query
        }

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/archiver-lambda-wrapper',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Clone data response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    //commit('setReport', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
}

